<template>
    <div class="full flex wrap center">
        <div class="cateogry full">
            <Tabs :meta="{
                type: 'tab',
                extras: `R0:key=data,value=${data?.entity?.grade && Number(data?.entity?.grade) <= 3 ? 'requests' : 'simple_requests'}`
            }" :vm="models['type'] || 'recheck'" @onchange="(obj) => models['type'] = obj.value"></Tabs>
        </div>
        <div class="item flex wrap center vcenter">
            <MetaBox :meta="{
                key: 'message',
                type: 'textarea',
                name: 'شرح درخواست'
            }" :vm="models['message'] || ''" @onchange="onchange"></MetaBox>
        </div>
        <div class="action flex wrap center vcenter">
            <Button :meta="{
                key: 'submit',
                name: 'ارسال درخواست'
            }" :active="loading" :disabled="disabled" @onclick="submit"></Button>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import Tabs from '../Form/Inputs/Tabs.vue'
import MetaBox from '../Form/Inputs/MetaBox.vue'
import Button from '../Form/Button.vue'

export default {
    name: 'Request',
    props: ['data'],
    inject: ['base'],
    components: { Tabs, MetaBox, Button },
    data() {
        return {
            models: {},
            errors: {},
            loading: false
        }
    },
    methods: {
        onchange(obj) {
            this.models[obj.key] = obj.value
            this.errors[obj.key] = obj.error
        },
        submit() {
            this.loading = true
            this.base.API().post(`Identities/File/SubmitRequest`, {
                data: [
                    Object.assign({
                        type: this.models['type'],
                        message: this.models['message']
                    }, this.data?.entity)
                ]
            }, (response) => {
                this.loading = false
                if (this.base.Util().success(response)) {
                    this.base.Notification().toast('نتیجه عملیات', 'درخواست با موفقیت ثبت گردید!', 'success')
                    this.$emit('onresult')
                } else
                    this.base.Notification().error({
                        code: response.data.errorCode,
                        referr: 'request'
                    })
            }, (error) => {
                this.loading = false
                this.base.Notification().error({
                    code: 5000,
                    text: 'خطایی رخ داد، لطفا مجددا تلاش کنید!'
                })
            })
        }
    }
}
</script>

<style scoped src="../../assets/css/components/dialogs/request.css"></style>